import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBhIEBuCGZVaeuL1xvWmgl6lPCm7AOzsS4",
  authDomain: "www.goodbyecar.com.br",
  projectId: "goodbyecar-app",
  storageBucket: "goodbyecar-app.firebasestorage.app",
  messagingSenderId: "443915402615",
  appId: "1:443915402615:web:cad6b22648d8b9d3963572",
  measurementId: "G-B5BE4JM2F4"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);


export { auth, db, storage };

